/* Americanflat header — mobile drawer menu (hamburger toggle, scrim, Esc). */
(function () {
  const toggle = document.querySelector('[data-af-menu-toggle]');
  const menu = document.querySelector('[data-af-mobile-menu]');
  const scrim = document.querySelector('[data-af-menu-scrim]');
  const closeBtn = document.querySelector('[data-af-menu-close]');
  if (!toggle || !menu) return;

  function setOpen(open) {
    menu.hidden = !open;
    if (scrim) scrim.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('af-menu-open', open);
    if (open) {
      // Let the hidden attribute clear before animating in.
      requestAnimationFrame(() => menu.classList.add('is-open'));
      if (scrim) requestAnimationFrame(() => scrim.classList.add('is-open'));
    } else {
      menu.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
    }
  }

  toggle.addEventListener('click', () => setOpen(menu.hidden));
  if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
  if (scrim) scrim.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) setOpen(false);
  });
})();

/* Cart icon → open the Dawn cart drawer when present (cart_type: drawer).
   Falls back to navigating to /cart if the drawer isn't on the page. */
(function () {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-af-cart-toggle]');
    if (!trigger) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // let the link navigate
    e.preventDefault();
    drawer.open(trigger);
  });
})();

/* Keep the header cart-count badge in sync after in-drawer quantity/remove
   changes. Dawn's cart.js re-renders only the cart-drawer section here (the
   #cart-icon-bubble section was dropped — see cart-drawer.js), so the header
   badge would otherwise go stale. Listen for the cart-update event instead. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event && event.cartData && event.cartData.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-af-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });
})();
